import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>GitHub - <a href="https://github.com/arabangoo" target="_blank" rel="noopener noreferrer">https://github.com/arabangoo</a></p>
      <p>Medium - <a href="https://arabangoo.medium.com" target="_blank" rel="noopener noreferrer">https://arabangoo.medium.com</a></p>
      <p>한국인공지능진흥협회(KAIPA) - <a href="https://huggingface.co/openfree" target="_blank" rel="noopener noreferrer">https://huggingface.co/openfree</a></p>
    </footer>
  );
};

export default Footer;